import { Collapse } from 'antd';
import css from './index.module.scss';
import { useGlobal } from '@/utils/useGlobal';
import EFArrowDown from '@/components/UI/svg/Icons/EFArrowDown';

export default function L({ langKey }: any) {
    const { useLang } = useGlobal();
    const { t } = useLang(langKey || 'poweroceancollection');

    const faqLists: any = [
        {
            question: t('secL_list1_q'),
            answer: t('secL_list1_a'),
        },
        {
            question: t('secL_list2_q'),
            answer: t('secL_list2_a'),
        },
        {
            question: t('secL_list3_q'),
            answer: t('secL_list3_a'),
        },
        {
            question: t('secL_list4_q'),
            answer: t('secL_list4_a'),
        },
        {
            question: t('secL_list5_q'),
            answer: t('secL_list5_a'),
        },
        {
            question: t('secL_list6_q'),
            answer: t('secL_list6_a'),
        },
        {
            question: t('secL_list7_q'),
            answer: t('secL_list7_a'),
        },
    ];

    return (
        <div className={`power-ocean-collection-L ${css['power-ocean-collection-L']}`}>
            <div className="text-box">
                <p className="title">{t('secL_title')}</p>
            </div>
            <Collapse
                ghost={true}
                className="collapse-lists"
                expandIcon={({ isActive }: any) => (
                    <EFArrowDown
                        style={{
                            transformOrigin: 'center',
                            transform: isActive ? 'translateY(-50%) rotate(180deg)' : 'translateY(-50%)',
                            transition: 'all .4s',
                        }}
                    />
                )}
                expandIconPosition="right"
            >
                {faqLists?.map((faq: any, k: number) => (
                    <Collapse.Panel className="list-title" key={k} header={faq.question}>
                        <p className="list-desc">{faq.answer}</p>
                    </Collapse.Panel>
                ))}
            </Collapse>
        </div>
    );
}
